import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../ampli';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useGetUserProfile } from '../../user/useGetUserProfile';

export const useAmplitude = () => {
  const location = useLocation();
  const { userProfile } = useGetUserProfile();

  useEffect(() => {
    const { pathname } = location;

    // TODO : pageInfo 적용 및 Switch 문으로 변경
    if (pathname === '/info/list') {
      ampli.정보목록페이지조회();
    } else if (pathname === '/home') {
      ampli.홈홈페이지조회();
    } else if (pathname === '/products/list') {
      ampli.마켓매물목록페이지조회();
    } else if (pathname === '/open-market/list') {
      ampli.마켓오픈마켓매물목록페이지조회();
    } else if (pathname === '/myinfo') {
      ampli.마이마이페이지조회();
    } else if (pathname === '/myinfo/edit-profile') {
      ampli.마이내정보수정페이지조회();
    } else if (pathname === '/noti') {
      ampli.마이공지사항페이지조회();
    } else if (pathname === '/myinfo/setting') {
      ampli.마이설정페이지조회();
    } else if (pathname === '/terms-of-use/list') {
      ampli.마이이용약관페이지조회();
    } else if (pathname === pageInfo.downloadAppPage.path) {
      ampli.pvmPageviewDownloadAppPage();
    } else if (pathname === pageInfo.sellTractorEntryPage.path) {
      ampli.pvmPageviewSellTractorEntry();
    } else if (pathname === pageInfo.pluvaAutoPage.path) {
      ampli.pvmPageviewPluvaAuto();
    }
  }, [location]);

  useEffect(() => {
    if (userProfile?.id) {
      ampli.client.setUserId(userProfile?.id);

      const pvmUserProperties = {
        pvm_user_logged_in: true,
        pvm_advertisement_term_agreed: userProfile?.advertisementTermsAgreement,
        pvm_user_id: userProfile?.id,
        pvm_user_email: userProfile?.email,
        pvm_user_phone_number: userProfile?.phoneNumber,
        pvm_user_region: `${userProfile?.regionDepth1} ${userProfile?.regionDepth2} ${userProfile?.regionDepth3}`,
      };

      ampli.identify(userProfile?.id, pvmUserProperties);
    } else {
      ampli.client.setUserId(undefined);
    }
  }, [userProfile]);
};
